module.exports = __webpack_public_path__ + "img/Robot-icon.649b1f5f.png";